/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_2_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start with the requirements that would stop your work if they failed. Examples include a VBA button that generates a report, a recurring data refresh, a shared workbook edited by several colleagues, or a customer who needs an exact Excel layout. Treat these as acceptance criteria before considering a switch.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_2_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先列出一旦失效就会影响工作的需求，例如生成报表的 VBA 按钮、定期数据刷新、多人共同编辑的文件，或者客户要求的准确 Excel 排版。考虑更换工具前，应先把这些设为验收标准。`)
};

/**
* | output |
* | --- |
* | "Start with the requirements that would stop your work if they failed. Examples include a VBA button that generates a report, a recurring data refresh, a shar..." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_2_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_2_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_2_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_2_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_2_paragraphs_0 as "gc.search_guides.gridcraft_vs_excel.sections.2.paragraphs.0" }